export const USER_COLLECTION_ID = 'users';

